/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveReferralRequestBody
 */
export interface RemoveReferralRequestBody {
    /**
     * 
     * @type {string}
     * @memberof RemoveReferralRequestBody
     */
    referralId: string;
}

export function RemoveReferralRequestBodyFromJSON(json: any): RemoveReferralRequestBody {
    return RemoveReferralRequestBodyFromJSONTyped(json, false);
}

export function RemoveReferralRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveReferralRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'referralId': json['referralId'],
    };
}

export function RemoveReferralRequestBodyToJSON(value?: RemoveReferralRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'referralId': value.referralId,
    };
}


